import { render, staticRenderFns } from "./ViewBlog.vue?vue&type=template&id=23a7b159&scoped=true&"
import script from "./ViewBlog.vue?vue&type=script&lang=js&"
export * from "./ViewBlog.vue?vue&type=script&lang=js&"
import style0 from "./ViewBlog.vue?vue&type=style&index=0&id=23a7b159&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a7b159",
  null
  
)

export default component.exports